import { Injectable } from '@angular/core'
import { ActiveCustomerGQL, CreateAddressInput, CreateCustomerAddressGQL, UpdateCustomerInput, UpdateCustomerGQL, RegisterCustomerInput, RegisterCustomerAccountGQL, UpdateCustomerPasswordGQL, VerifyCustomerAccountGQL } from '../gql/generated'
import { LoaderService } from './loader.service'
import { tap } from 'rxjs/operators'
import { NzNotificationService } from 'ng-zorro-antd/notification'

@Injectable({
    providedIn: 'root',
})
export class CustomerService {
    constructor(
        private loaderService: LoaderService,
        private activeCustomerGQL: ActiveCustomerGQL,
        private createCustomerAddressGQL: CreateCustomerAddressGQL,
        private updateCustomerGQL: UpdateCustomerGQL,
        private registerCustomerAccountGQL: RegisterCustomerAccountGQL,
        private updateCustomerPasswordGQL: UpdateCustomerPasswordGQL,
        private verifyCustomerAccountGQL: VerifyCustomerAccountGQL,
        private nzNotificationService: NzNotificationService
    ) {}

    getActiveCustomer() {
        return this.loaderService.withLoader(
            () => this.activeCustomerGQL.fetch(
              {},
              {
                context: {
                  headers: {
                    'vendure-token': 'K7',
                  },
                },
                fetchPolicy: 'network-only'
              }).pipe(
                tap({
                    next: (response) => {
                        console.log(response)
                    }
                })
            ),
            CustomerService.name
        )
    }

    createCustomerAddress(input: CreateAddressInput) {
        return this.loaderService.withLoader(
            () => this.createCustomerAddressGQL.mutate(
              { input },
              {
                context: {
                  headers: {
                    'vendure-token': 'K7',
                  },
                }
              }
            ).pipe(
                tap({
                    next: (response) => {
                        console.log(response)
                    }
                })
            ),
            CustomerService.name
        )
    }

    updateCustomer(input: UpdateCustomerInput) {
        return this.loaderService.withLoader(
            () => this.updateCustomerGQL.mutate(
              { input },
              {
                context: {
                  headers: {
                    'vendure-token': 'K7',
                  },
                }
              }
            ).pipe(
                tap({
                    next: (response) => {
                        const error = response.data?.updateCustomer as {
                            errorCode?: string
                            message?: string
                          }
                          if (error?.errorCode) {
                            this.nzNotificationService.error(
                              error.errorCode,
                              error.message as string
                            )
                        }
                    }
                })
            ),
            CustomerService.name
        )
    }

    registerCustomerAccount(input: RegisterCustomerInput) {
        return this.loaderService.withLoader(
            () => this.registerCustomerAccountGQL.mutate(
              { input },
              {
                context: {
                  headers: {
                    'vendure-token': 'K7',
                  },
                }
              }
            ).pipe(
                tap({
                    next: (response) => {
                        console.log(response)
                    }
                })
            ),
            CustomerService.name
        )
    }

    updateCustomerPassword(currentPassword: string, newPassword: string) {
        return this.loaderService.withLoader(
            () => this.updateCustomerPasswordGQL.mutate(
              { currentPassword, newPassword },
              {
                context: {
                  headers: {
                    'vendure-token': 'K7',
                  },
                }
              }
            ).pipe(
                tap({
                    next: (response) => {
                        console.log(response)
                    }
                })
            ),
            CustomerService.name
        )
    }

    verifyCustomerAccount(token: string){
        return this.loaderService.withLoader(
            () => this.verifyCustomerAccountGQL.mutate(
              { token },
              {
                context: {
                  headers: {
                    'vendure-token': 'K7',
                  },
                }
              }
            ).pipe(
                tap({
                    next: (response) => {
                        console.log(response)
                    }
                })
            ),
            CustomerService.name
        )
    }
}
